import { isEqual } from 'lodash'

import { GenericalRecord } from '@eastcoal/common/types/utilities'

/**
 * 比较 UI 跟 Node 状态是否相等
 *
 * @param uiState ui状态
 * @param nodeState 节点状态
 * @param keys 需要同步的属性集合
 * @returns 是否相等
 */
export const isEqualState = <
  U extends GenericalRecord,
  N extends GenericalRecord,
  K extends Extract<keyof U, keyof N>
>(
  uiState: U,
  nodeState: N,
  keys: K[]
) => {
  return keys.every(key => isEqual(uiState[key], nodeState[key]))
}
